<template>
  <div class="main-content" id="panel">
    <!-- Header -->
    <!-- <Header /> -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-9 col-6">
              <h2>Set Quantity & Capital</h2>
            </div>
            <div class="col-lg-3 col-6 text-right bid">
                <!-- <div class="input-group">
                    <input  v-on:keyup.enter="searchTrader" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control py-2 border-right-0 border" placeholder="Search trader"  type="search" value="search" id="example-search-input">
                    <span class="input-group-append">
                        <div  @click="searchTrader()" class="input-group-text bg-transparent"><i class="fa fa-search"></i></div>
                    </span>
                </div> -->
                <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                  <i @click="searchTrader()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                  <input v-on:keyup.enter="searchTrader" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search Trader" aria-label="Search">
                  <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                </form>
              </div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <div class="card vh-75" id="scroll">
            <div class="table-responsive">
              <div v-if="loading" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firstName'  ? 'sort-desc' : '']"  
                      @click="sort('firstName')" >Trader</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'email'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'email'  ? 'sort-desc' : '']"  
                      @click="sort('email')" >Email</th>
                    <!-- <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'createdAt'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'createdAt'  ? 'sort-desc' : '']"  
                      @click="sort('createdAt')" >Created Date</th> -->
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maxCusips'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maxCusips'  ? 'sort-desc' : '']"  
                      @click="sort('maxCusips')"><i class="fas fa-info-circle" data-toggle="tooltip" v-bind:title="appMessages.maxOfCusipTooltipText"></i> Max. # of cusip</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maxParValue'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maxParValue'  ? 'sort-desc' : '']"  
                      @click="sort('maxParValue')"><i class="fas fa-info-circle" data-toggle="tooltip" v-bind:title="appMessages.maxParvalueTooltipText"></i> Max. Par Value/Cusip</th>
                    
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maxCapital'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maxCapital'  ? 'sort-desc' : '']"  
                      @click="sort('maxCapital')">Max. Capital</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'status'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'status'  ? 'sort-desc' : '']"  
                      @click="sort('status')">Status</th>
                    <th scope="col" class=" text-center">Action</th>
                  </tr>
                </thead>
                <tbody class="list no-cursor">
                  <tr v-if="totalRows == 0 && !loading">
                    <td><p class="nodata">No data available</p>
                    </td>
                  </tr>
                  <tr v-for="trader in traders" :key="trader.id">
                    <td  class="btn-link"  @click="openModal();traderData = trader" >{{trader.firstName[0]}}. {{trader.lastName}}</td>
                    <td>{{trader.email}}</td>
                    <!-- <td>{{moment(trader.maturityDate).format("MM/DD/YYYY")}}</td> -->
                    <td><input type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57"  class=" form-control form-control-sm capital-w" v-model="trader.maxCusips" /></td>
                    <td><input type="text" @keyup="formatToComma(trader)" onkeypress="return event.charCode >= 48 && event.charCode <= 57"  class="form-control form-control-sm capital-w" v-model="trader.maxParValue"/></td>
                    <td class="input-d">
                      <i class="fas fa-dollar-sign"></i>
                      <currency-input
                        v-model="trader.maxCapital"
                        class="form-control capital-w"
                      />
                    </td>
                    <!-- <td><input type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57"  class="col-md-5 form-control form-control-sm" v-model="trader.maxCapital" /></td> -->
                    <td class="text-center"><span class="badge" v-bind:class="trader.status == 'ACTIVE' ? 'active' : 'deactive'">{{trader.status == 'ACTIVE' ? 'ACTIVE' : 'INACTIVE'}}</span></td>
                    <td class="text-center">
                      <button :disabled="trader.maxParValue == 0 || trader.maxCusips == 0 || trader.maxCapital == 0" type="button" @click="setTraderData(trader)" class="btn btn-success btn-sm my-2 autowidth"><i class="fas fa-check"></i> SAVE</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getTraderList(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{totalRows}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer /> -->
      <trader-info v-bind:traderInfo="traderData" v-if="modalOpen" @close="modalOpen = false"></trader-info>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import TraderInfo from "./TraderInfoPopup"
export default {
  name: "traders",
  components: {
    // Header,
    // Footer,
    TraderInfo
  },
  data() {
    return {
      accessToken: null,
      traders: [],
      config: config,
      loading : false,
      currentPage: 1,
      perPage: 10,
      searchValue : "",
      totalRows : 0,
      sortColumn: "firstName",
      sortOrder: "ASC",
      tenantName:null,
      bidSettings : {},
      selectedTrader : {},
      modalOpen: false,
      traderData:{}

    };
  },
  created() {

  },
  methods: {
    formatToComma(trader){
      const result = trader.maxParValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      trader.maxParValue = result;
    },
    getCommaSeperatedValue(num){
      return num.toString().replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    openModal() {
      this.modalOpen = !this.modalOpen;
    },    
    searchTrader(){
      this.getTraderList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getTraderList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getTraderList();
    },
    getTraderList(){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user/list?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&group="+this.tenantName+"-Trader",
            auth
        )
        .then(result => {
          // console.log("222",this.bidSettings);
          this.totalRows = result.data.pageInfo.totalElements;
          var self = this;
          result.data.content.forEach(function(trader) {
            //console.log(trader,self.bidSettings.maxParValue);
            trader.maxCusips == null ? trader.maxCusips  = self.bidSettings.maxCusips : 0;
            trader.maxCapital == null ? trader.maxCapital = self.bidSettings.maxCapital : 0;
            trader.maxParValue == null ? trader.maxParValue = self.getCommaSeperatedValue(self.bidSettings.maxParValue) : trader.maxParValue = self.getCommaSeperatedValue(trader.maxParValue);
            console.log()
          });
          this.traders = result.data.content;

          this.loading = false;
          
        })
        .catch(e => {
          console.log(e);
        });
    },
    setTraderData(trader){
      
      trader.maxParValue = parseFloat(trader.maxParValue.replace(/,/g, ''));

      if(parseFloat(trader.maxParValue % 5)){
        this.$alert(this.appMessages.parValueMultipleFiveError,"","warning");     
        return false
      }

      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .put(
          config.baseUrlBidSide + "/user",
          trader,
          auth
        )
        .then(response => {
          console.log(response);
          this.$alert(this.appMessages.traderDataUpdated);
          this.getTraderList()
        })
        .catch(e => {
          console.log(e);
        });
    },
    getBidSettings(){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide + "/organization/bid-settings?type=BID",
          auth
        )
        .then(response => {
          this.bidSettings = response.data;
          this.getTraderList();
          
        })
        .catch(e => {
          console.log(e);
        });
    },

  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        console.log(err);

        this.accessToken = result;
        this.$cognitoAuth.getUserGroup((err, role) => {
          if (err) {
            console.log("accessToken is not found", err);
          } else {
            this.tenantName = role[0].split("-")[0];
            this.getBidSettings();

          }
        });
      }
    }); 
  }
};
</script>
<style scoped>
</style>